// @ts-nocheck

import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { ENV_PROD } from '../../constants/environment';
import useRouter from '../../hooks/useRouter';
import { isLibrary } from '../../lib/useragent';
import BetslipOptionsRouterSwitch from '../../modules/betslip-options/components/BetslipOptionsRouterSwitch/BetslipOptionsRouterSwitch';
import LineUpRouterSwitch from '../../modules/line-up/components/LineUpRouterSwitch/LineUpRouterSwitch';
import MissionsRouterSwitch from '../../modules/missions/components/MissionsRouterSwitch';
import { RoutePatterns } from '../../types/routes';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';
import HistoryContainer from '../History/HistoryContainer';
import LandingContainer from '../Landing/LandingContainer';
import MultiviewContainer from '../Multiview/MultiviewContainer';
import RoutesCalendarContainer from '../RoutesCalendar/RoutesCalendarContainer';
import RoutesCatalogContainer from '../RoutesCatalog/RoutesCatalogContainer';
import RoutesFavoriteContainer from '../RoutesFavorite/RoutesFavoriteContainer';
import RoutesHomeContainer from '../RoutesHome/RoutesHomeContainer';
import RoutesLiveContainer from '../RoutesLive/RoutesLiveContainer';
import RoutesMatchContainer from '../RoutesMatch/RoutesMatchContainer';
import WinaLoader from '../WinaLoader';

const MiddleColumnWrapper = styled.div`
  ${({ $isMultiview, theme }) =>
    $isMultiview
      ? css`
          width: 100%;
          min-width: auto;
          position: relative;
        `
      : css`
          width: ${!isLibrary ? '370px' : '300px'};
          flex-shrink: 0;

          @media screen and (min-width: ${theme.breakpoints.md}px) {
            width: 500px;
          }
        `}
`;

type DesktopBettingLayoutMiddleColumnProps = {
  isMultiview: boolean;
};

const BetshareTool = () => {
  const {
    history,
    params: { betslipReference },
  } = useRouter();

  if (betslipReference) {
    history.push(RoutesRedirectionFactory.getHistoryShareBetslipRoutePathname(betslipReference));
  }
  return null;
};

/**
 * Display the middle column for the betting section
 *
 * @param  {boolean}  isMultiview Detect if we are in multiview
 * @return {ReactNode}            A styled component wrapper with a landing container and all the necessary routes
 */
const DesktopBettingLayoutMiddleColumn = ({ isMultiview }: DesktopBettingLayoutMiddleColumnProps) => {
  return (
    <MiddleColumnWrapper $isMultiview={isMultiview} data-testid="middleColumn">
      <LandingContainer />
      <Suspense fallback={<WinaLoader />}>
        <Switch>
          <Route path={RoutePatterns.FAVORITES} exact>
            <RoutesFavoriteContainer />
          </Route>
          <Route path={RoutePatterns.LIVE} exact>
            <RoutesLiveContainer />
          </Route>
          <Route path={RoutePatterns.CALENDAR} exact>
            <RoutesCalendarContainer />
          </Route>
          <Route path={RoutePatterns.CATALOG} exact>
            <RoutesCatalogContainer />
          </Route>
          <Route path={RoutePatterns.HISTORY} exact>
            <HistoryContainer />
          </Route>
          <Route path={RoutePatterns.MATCH}>
            <RoutesMatchContainer />
            <LineUpRouterSwitch />
          </Route>

          <Route path={RoutePatterns.MULTIVIEW} exact>
            <MultiviewContainer />
          </Route>
          <Route path={RoutePatterns.BETBUILDER} exact>
            <RoutesMatchContainer />
          </Route>
          <Route path={RoutePatterns.HOME} exact>
            <RoutesHomeContainer />
          </Route>

          {process.env.REACT_APP_BUILD_ENV !== ENV_PROD ? (
            <Route path={'/_tools/betshare/:betslipReference'} exact>
              <BetshareTool />
            </Route>
          ) : null}
        </Switch>

        <BetslipOptionsRouterSwitch />
        <MissionsRouterSwitch />
      </Suspense>
    </MiddleColumnWrapper>
  );
};

export default DesktopBettingLayoutMiddleColumn;
